import {
  Box,
  Button,
  Select,
  Tooltip,
  CircularProgress,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Switch,
  MenuItem,
} from '@material-ui/core';
import { useRoutes } from 'hookrouter';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createCustomer,
  getCustomerDetails,
  setCustomerSelector,
  resetCustomerStates,
  createCustomerSelector,
  getAccountDetailsSelector,
  setAccountSearchResponseLengthSelector,
  getAccountDetails,
  createCustomerSelectorv2,
  createCustomerv2,
} from '../../services/homeSlice';
import Routes from '../routes/routes';
import NavBar from '../NavBar/navbar';
import Swal from 'sweetalert2';
import SearchIcon from '@material-ui/icons/Search';
import PublicIcon from '@material-ui/icons/Public';
import NoteIcon from '@material-ui/icons/Note';
import { navigate } from 'hookrouter';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ReceiptIcon from '@material-ui/icons/Receipt';
import axios from 'axios';
import { Editor, EditorState, ContentState } from 'draft-js';

import { blue } from '@material-ui/core/colors';
import SendIcon from '@material-ui/icons/Send';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudIcon from '@material-ui/icons/Cloud';
import UploadData from '../Upload/upload';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import MuiAlert from '@material-ui/lab/Alert';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreIcon from '@material-ui/icons/RestoreFromTrash';
import SettingsIcon from '@material-ui/icons/Settings';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';

const useStyles = makeStyles((theme) => ({
  wrap: {
    margin: theme.spacing(4),
  },
  tooltip: {
    fontSize: '1em',
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(3),
  },
  btn: {
    display: 'flex',
    float: 'right',
    marginRight: '30px',
  },
  homeActionBarItem: {
    display: 'flex',
    float: 'right',
    marginRight: '40px',
    marginTop: '20px',
    marginBottom: '20px',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
  },
  rowBtn: {
    margin: theme.spacing(1),
  },
  dialogBox: {
    padding: theme.spacing(1),
    textAlign: 'center',
  },
  root: {
    padding: theme.spacing(3),
    '& .MuiFormControl-root': {
      width: '100%',
      textAlign: 'left',
      padding: '0',
    },
  },
}));

const columns = [
  { id: 'id', label: 'CustomerId', minWidth: 50 },
  { id: 'name', label: 'Customer Name', minWidth: 170 },
  { id: 'created', label: 'Created On', minWidth: 170 },
  { id: 'updated', label: 'Updated On', minWidth: 170 },
  { id: 'actions', label: '', minWidth: 170 },
];

const accountColumns = [
  { id: 'id', label: 'Account ID', minWidth: 50 },
  { id: 'name', label: 'Account Name', minWidth: 170 },
  { id: 'zip', label: 'Default zip radius', minWidth: 100 },
  { id: 'add', label: '', minWidth: 100 },
];

export default function Home() {
  useRoutes(Routes);

  const api = '/api/';

  if ('Handler' in localStorage) {
    let item = localStorage.getItem('Handler');
    clearInterval(JSON.parse(item));
    localStorage.removeItem('Handler');
  }

  if (localStorage.getItem('auth') !== 'true') {
    navigate('/', true);
  }

  const classes = useStyles();
  const dispatch = useDispatch();

  const [dispatched, setDispatched] = useState(false);
  const [settingsForSelectedCustomer, setSettingsForSelectedCustomer] = useState(null);
  const [details, setDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [searchdata, setsearchdata] = useState([]);
  const [accountName, setaccountName] = useState('');
  const [accountNumber, setaccountNumber] = useState('');
  const [snackMessage, setsnackMessage] = useState('');
  const [hasSnacks, sethasSnacks] = useState(false);
  const [snackTemplate, setsnackTemplate] = useState('');
  const [moderator, setmoderator] = useState(false);
  const customerDetails = useSelector(setCustomerSelector);
  const customerResponse = useSelector(createCustomerSelector);
  const customerResponsev2 = useSelector(createCustomerSelectorv2);
  const accountsResponse = useSelector(getAccountDetailsSelector);
  const accountResponseLength = useSelector(setAccountSearchResponseLengthSelector);
  const [customerLoader, setcustomerLoader] = useState(false);
  const [errorLoader, setErrorLoader] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [selectedFordisableCustomerDetails, setSelectedFordisableCustomerDetails] = useState(null);
  const [showDisabled, setShowDisabled] = useState(false);

  const zipSelectionRef = useRef();

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const editor = useRef(null);

  function focusEditor() {
    editor.current.focus();
  }

  //   useEffect(() => {
  //     focusEditor()
  //   }, []);

  if (!dispatched) {
    dispatch(getCustomerDetails());
    setDispatched(true);
  }

  useEffect(() => {
    if (moderator === true) {
      console.log('Changes detected');
      sethasSnacks(true);
      setmoderator(false);
    }
  }, [moderator]);

  useEffect(() => {
    if (customerDetails.length !== 0) {
      setDetails(customerDetails);
      localStorage.setItem('userId', customerDetails[0].id);
      if ('uploads' in localStorage) {
        let current = [];
        let uploads = JSON.parse(localStorage.getItem('uploads'));
        for (let i = 0; i < uploads.length; i++) {
          current.push(uploads[i]);
        }
        if (current.length !== 0) {
          for (let i = 0; i < current.length; i++) {
            console.log('here');
            axios
              .get(api + 'uploadprogress/' + current[i])
              .then((response) => {
                let jsonResponse = response.data;
                if (jsonResponse.status === 'Completed') {
                  console.log('Open snack');
                  let msg = 'Upload of ' + unescape(jsonResponse.filename) + ' completed';
                  localStorage.setItem(
                    'snack',
                    JSON.stringify({
                      msg: msg,
                      tempid: jsonResponse.template.id,
                    }),
                  );
                  // setsnackMessage(msg);
                  // setsnackTemplate(jsonResponse.template.id);
                  try {
                    setmoderator(true);
                  } catch (e) {
                    console.log(e);
                  }
                  console.log('Done');
                  current.splice(i, 1);
                  console.log(current);
                  if (current.length != 0) {
                    localStorage.setItem('uploads', JSON.stringify(current));
                  } else {
                    localStorage.removeItem('uploads');
                  }
                }
              })
              .catch((error) => {
                console.log('Fetch data error');
                console.log(error);
              });
          }
        } else {
          localStorage.removeItem('uploads');
        }
      }
    } else {
      console.log('hello');
    }
    setmoderator(false);
    fetchDetails();
    return;
  }, [customerDetails]);

  useEffect(() => {
    if (searchdata.length !== 0) {
      setcustomerLoader(false);
    }
  }, [searchdata]);

  useEffect(() => {
    if (accountsResponse.length !== 0) {
      setsearchdata(accountsResponse);
    } else if (accountResponseLength === 0) {
      // API called but no data from backend
      setsearchdata([]);
      setcustomerLoader(false);
      setErrorLoader(true);
    } else {
      setsearchdata([]);
    }
  }, [accountsResponse, accountResponseLength]);

  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
    setsearchdata([]);
  };

  const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  };

  const handleFormChangeName = (e) => {
    setaccountName(e.target.value);
  };

  const updateNotes = () => {
    const notes = editorState.getCurrentContent().getPlainText();
    console.log(notes);
    const customerId = selectedCustomerId;

    axios
      .post(api + 'customer/editnotes/' + customerId, notes, {
        headers: { 'Content-Type': 'text/plain' },
      })
      .then(() => {
        setSelectedCustomerId(null);
        setDispatched(false);
      });
  };

  const updateSettings = () => {
    console.log(settingsForSelectedCustomer);
    const customerId = settingsForSelectedCustomer?.customerId;
    if (customerId) {
      axios
        .post(api + 'customer/editsettings/' + customerId, {
          defaultZipSelection:
            settingsForSelectedCustomer?.defaultZip === 'No Default'
              ? null
              : settingsForSelectedCustomer?.defaultZip,
          resultLimit: settingsForSelectedCustomer?.resultLimit
            ? settingsForSelectedCustomer.resultLimit
            : null,
          mapView: settingsForSelectedCustomer?.mapView,
          distanceCalcMethod: settingsForSelectedCustomer?.distanceCalcMethod,
          geofenceView: settingsForSelectedCustomer?.geofenceView,
        })
        .then(() => {
          setDispatched(false);
          setSettingsForSelectedCustomer(null);
        });
    }
  };

  const toggleCustomerStatus = (customerId) => {
    axios.post(api + 'customer/toggleactive/' + customerId).then(() => {
      setSelectedFordisableCustomerDetails(null);
      setDispatched(false);
    });
  };

  const fetchDetails = () => {
    let timeHandler = setInterval(() => {
      if ('uploads' in localStorage) {
        let current = [];
        let uploads = JSON.parse(localStorage.getItem('uploads'));
        for (let i = 0; i < uploads.length; i++) {
          current.push(uploads[i]);
        }
        if (current.length !== 0) {
          for (let i = 0; i < current.length; i++) {
            console.log('here');
            axios
              .get(api + 'uploadprogress/' + current[i])
              .then((response) => {
                let jsonResponse = response.data;
                if (jsonResponse.status === 'Completed') {
                  console.log('Open snack');
                  let msg = 'Upload of ' + unescape(jsonResponse.filename) + ' completed';
                  localStorage.setItem(
                    'snack',
                    JSON.stringify({
                      msg: msg,
                      tempid: jsonResponse.template.id,
                    }),
                  );
                  // setsnackMessage(msg);
                  // setsnackTemplate(jsonResponse.template.id);
                  sethasSnacks(true);
                  console.log('Done');
                  current.splice(i, 1);
                  console.log(current);
                  if (current.length != 0) {
                    localStorage.setItem('uploads', JSON.stringify(current));
                  } else {
                    localStorage.removeItem('uploads');
                  }
                }
              })
              .catch((error) => {
                console.log('Fetch data error');
                console.log(error);
              });
          }
        } else {
          localStorage.removeItem('uploads');
        }
      }
    }, 10000);

    localStorage.setItem('uploadTimeHandler', timeHandler);
  };

  const handleFormChangeNumber = (e) => {
    setaccountNumber(e.target.value);
  };

  const submit = (accNum, accName) => {
    const zipSelection =
      zipSelectionRef.current.value != 'No Default' ? zipSelectionRef.current.value : '';

    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    dispatch(
      createCustomerv2({
        accountNum: accNum,
        defaultZipSelection: zipSelection,
      }),
    );
  };

  const handleClose = (event, reason) => {
    let id = JSON.parse(localStorage.getItem('snack'))['tempid'];
    sethasSnacks(false);
    // setsnackTemplate('');
    // setsnackMessage('');
    localStorage.removeItem('snack');
    navigate('/uploads/' + id);
  };

  const handleExit = (e, reason) => {
    sethasSnacks(false);
    localStorage.removeItem('snack');

    // setsnackTemplate('');
    // setsnackMessage('');
  };

  const search = () => {
    if (localStorage.getItem('auth') !== 'true') {
      navigate('/', true);
    }
    setcustomerLoader(true);
    dispatch(getAccountDetails(accountName, accountNumber));
  };

  // const onKeySubmit = (event) => {

  //     if(event.key === "Enter")
  //     {
  //         if(name !== ""){
  //             if(localStorage.getItem("auth") !== "true"){
  //                 navigate("/", true)
  //               }
  //             dispatch(createCustomer({
  //                 name: name
  //             }))
  //             closeDialog()
  //         }
  //         else
  //         {
  //             console.log("Incomplete details")
  //         }
  //     }
  // }

  const handleOpenNotes = (customerId, notes) => {
    setSelectedCustomerId(customerId);
    if (notes) setEditorState(EditorState.createWithContent(ContentState.createFromText(notes)));
    else setEditorState(EditorState.createEmpty());
    // editor.focus();
  };

  const handleSettingsForCustomer = (customerId, defaultZip, resultLimit, mapView, distanceCalcMethod, geofenceView) => {
    setSettingsForSelectedCustomer({ customerId, defaultZip, resultLimit, mapView, distanceCalcMethod, geofenceView });
  };

  const handleToggle = (customerId, customerName, currentDisableStatus) => {
    setSelectedFordisableCustomerDetails({ customerId, customerName, currentDisableStatus });
  };

  const handleRoute = (evt, id) => {
    localStorage.setItem('userId', id);
    switch (evt) {
      case 'Forms':
        navigate('/template/' + id);
        break;
      case 'Search':
        navigate('/' + id);
        break;
      case 'Upload':
        navigate('/upload/' + id);
        break;
      case 'Uploads':
        navigate('/uploads/' + id);
        break;
      case 'Geofence':
        navigate('/geofence/' + id);
        break;
    }
  };

  useEffect(() => {
    if (customerResponse.length != 0) {
      closeDialog();
      Swal.fire({
        text: 'Customer created successfully',
        icon: 'success',
      }).then((result) => {
        setName('');
        dispatch(resetCustomerStates());
        if (localStorage.getItem('auth') !== 'true') {
          navigate('/', true);
        }
        dispatch(getCustomerDetails());
      });
    }
  }, [customerResponse]);

  useEffect(() => {
    console.log('v2' + customerResponsev2);
    if (customerResponsev2.length != 0) {
      closeDialog();
      Swal.fire({
        text: 'Customer created successfully',
        icon: 'success',
      }).then((result) => {
        setName('');
        setaccountName('');
        setaccountNumber('');
        setsearchdata([]);
        dispatch(resetCustomerStates());
        if (localStorage.getItem('auth') !== 'true') {
          navigate('/', true);
        }
        dispatch(getCustomerDetails());
      });
    } else {
      setaccountName('');
      setaccountNumber('');
      setsearchdata([]);
    }
  }, [customerResponsev2]);

  return (
    <>
      <NavBar />
      <Typography variant="h5" className={classes.header}>
        Customer Details
      </Typography>

      <Button
        variant="outlined"
        startIcon={<AddCircleIcon />}
        color="primary"
        className={classes.homeActionBarItem}
        onClick={openDialog}
      >
        Add Customer
      </Button>

      <FormControlLabel
        className={classes.homeActionBarItem}
        control={
          <Switch checked={showDisabled} onChange={() => setShowDisabled(!showDisabled)}></Switch>
        }
        label="Show disabled customers"
      />

      {/* <Switch label="Show disabled customers" className={classes.homeActionBarItem}>
            Show disabled customers
        </Switch> */}
      <Paper className={classes.wrap}>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {details
                ? details
                  .filter((item) => showDisabled || !item.isDisabled)
                  .map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{new Date(row.createdOn).toLocaleString()}</TableCell>
                        <TableCell>{new Date(row.updatedOn).toLocaleString()}</TableCell>
                        <TableCell>
                          <Tooltip classes={{ tooltip: classes.tooltip }} title="Settings">
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() =>
                                handleSettingsForCustomer(
                                  row.id,
                                  row.defaultZipSelection,
                                  row.resultLimit,
                                  row.mapView,
                                  row.distanceCalcMethod,
                                  row.geofenceView
                                )
                              }
                              className={classes.rowBtn}
                            >
                              {' '}
                              <SettingsIcon />
                            </Button>
                          </Tooltip>
                          <Tooltip classes={{ tooltip: classes.tooltip }} title="Add Notes">
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => handleOpenNotes(row.id, row.notes)}
                              className={classes.rowBtn}
                            >
                              {' '}
                              <NoteIcon />
                            </Button>
                          </Tooltip>
                          <Tooltip classes={{ tooltip: classes.tooltip }} title="Go to Search">
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => handleRoute('Search', row.id)}
                              className={classes.rowBtn}
                            >
                              <SearchIcon />
                            </Button>
                          </Tooltip>
                          {
                            row.geofenceView && (
                              <Tooltip classes={{ tooltip: classes.tooltip }} title="Go to Geofence">
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={() => handleRoute('Geofence', row.id)}
                                  className={classes.rowBtn}
                                >
                                  <PublicIcon />
                                </Button>
                              </Tooltip>
                            )
                          }
                          <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<ReceiptIcon />}
                            onClick={() => handleRoute('Forms', row.id)}
                            className={classes.rowBtn}
                          >
                            Manage Templates
                          </Button>
                          <Button
                            variant="outlined"
                            color={row.isDisabled ? 'default' : 'secondary'}
                            startIcon={row.isDisabled ? <RestoreIcon /> : <DeleteIcon />}
                            onClick={() => handleToggle(row.id, row.name, row.isDisabled)}
                            className={classes.rowBtn}
                          >
                            {row.isDisabled ? 'Enable' : 'Disable'}
                          </Button>
                          {/* <Button variant="outlined" color="primary" startIcon={<CloudUploadIcon />} onClick={() => handleRoute('Upload', row.id)} className={classes.rowBtn}>
                                        Upload Data
                                    </Button> */}
                          {/* <Button variant="outlined" color="primary" startIcon={<CloudIcon />} onClick={() => handleRoute('Uploads', row.id)} className={classes.rowBtn}>
                                        Uploads
                                    </Button> */}
                        </TableCell>
                      </TableRow>
                    );
                  })
                : 'No Data to Display'}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog open={open} fullWidth={true} maxWidth={'md'} onClose={closeDialog}>
        <DialogContent className={classes.dialogBox}>
          <Typography variant="h6" className={classes.header}>
            CREATE CUSTOMER
          </Typography>
          <div className={classes.root}>
            <Grid container spacing={0}>
              <Grid item md={5} sm={12} xs={12}>
                <TextField
                  name="accountName"
                  label="Account Name"
                  variant="outlined"
                  value={accountName}
                  onChange={handleFormChangeName}
                />
              </Grid>
              <Grid item md={2} sm={12} xs={12}>
                <Typography variant="h6" style={{ marginTop: '10px' }}>
                  or
                </Typography>
              </Grid>
              <Grid item md={5} sm={12} xs={12}>
                <TextField
                  name="accountNumber"
                  label="Account Number"
                  variant="outlined"
                  value={accountNumber}
                  onChange={handleFormChangeNumber}
                />
              </Grid>
            </Grid>
            <Button
              style={{ width: '100px', margin: '20px' }}
              startIcon={<SearchIcon />}
              variant="outlined"
              size="small"
              type="submit"
              onClick={search}
            >
              Search
            </Button>

            {searchdata.length !== 0 && (
              <Paper className={classes.wrap}>
                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {accountColumns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {searchdata
                        ? searchdata.map((row) => {
                          return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                              <TableCell>{row.id}</TableCell>
                              <TableCell>{row.name}</TableCell>
                              <TableCell>
                                <Select inputRef={zipSelectionRef} defaultValue="No Default">
                                  <MenuItem value="No Default">No Default</MenuItem>
                                  <MenuItem value="25">25</MenuItem>
                                  <MenuItem value="50">50</MenuItem>
                                  <MenuItem value="75">75</MenuItem>
                                  <MenuItem value="100">100</MenuItem>
                                </Select>
                              </TableCell>
                              <TableCell>
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  startIcon={<AddCircleIcon />}
                                  onClick={() => submit(row.id, row.name)}
                                  className={classes.rowBtn}
                                >
                                  Add
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })
                        : 'No Data to Display'}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            )}
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={customerLoader}>
        <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
          <CircularProgress />
          <Typography variant="h6">Fetching Customer Details</Typography>
        </DialogContent>
      </Dialog>

      <Dialog disableBackdropClick={false} open={selectedCustomerId !== null}>
        <DialogTitle>Notes</DialogTitle>
        <DialogContent>
          <Editor
            ref={editor}
            editorState={editorState}
            onChange={(editorState) => setEditorState(editorState)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectedCustomerId(null)}>Cancel</Button>
          <Button onClick={() => updateNotes()}>Save</Button>
        </DialogActions>
      </Dialog>

      <Dialog disableBackdropClick={false} open={!!settingsForSelectedCustomer}>
        <DialogTitle>Settings for Customer {settingsForSelectedCustomer?.customerId}</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item sm={8}>
              Result Limit:
            </Grid>

            <Grid item sm={4}>
              <TextField
                type="number"
                min
                value={
                  settingsForSelectedCustomer?.resultLimit
                    ? settingsForSelectedCustomer.resultLimit
                    : ''
                }
                onChange={(e) =>
                  setSettingsForSelectedCustomer({
                    ...settingsForSelectedCustomer,
                    resultLimit: e.target.value <= 0 ? '' : e.target.value,
                  })
                }
              ></TextField>
            </Grid>

            <Grid item sm={8}>
              Default Distance from Zip or Address:{' '}
            </Grid>
            <Grid item sm={4}>
              <Select
                // defaultValue={settingsForSelectedCustomer?.defaultZip ? settingsForSelectedCustomer.defaultZip : "No Default"}
                value={
                  settingsForSelectedCustomer?.defaultZip
                    ? settingsForSelectedCustomer.defaultZip
                    : 'No Default'
                }
                onChange={(e) =>
                  setSettingsForSelectedCustomer({
                    ...settingsForSelectedCustomer,
                    defaultZip: e.target.value,
                  })
                }
              >
                <MenuItem value="No Default">No Default</MenuItem>
                <MenuItem value="25">25</MenuItem>
                <MenuItem value="50">50</MenuItem>
                <MenuItem value="75">75</MenuItem>
                <MenuItem value="100">100</MenuItem>
                <MenuItem value="125">125</MenuItem>
                <MenuItem value="150">150</MenuItem>
                <MenuItem value="175">175</MenuItem>
                <MenuItem value="200">200</MenuItem>
              </Select>
            </Grid>

            <Grid item sm={8}>
              Address Distance Calculation Method:{' '}
            </Grid>
            <Grid item sm={4}>
              <Select
                // defaultValue={settingsForSelectedCustomer?.defaultZip ? settingsForSelectedCustomer.defaultZip : "No Default"}
                value={
                  settingsForSelectedCustomer?.distanceCalcMethod
                    ? settingsForSelectedCustomer.distanceCalcMethod
                    : 'GEO_DISTANCE'
                }
                onChange={(e) =>
                  setSettingsForSelectedCustomer({
                    ...settingsForSelectedCustomer,
                    distanceCalcMethod: e.target.value,
                  })
                }
              >
                <MenuItem value="GEO_DISTANCE">Geo Distance Formula</MenuItem>
                <MenuItem value="GOOGLE_MAPS">Google Maps Api</MenuItem>
              </Select>
            </Grid>

            <Grid item sm={8}>
              Map View:
            </Grid>

            <Grid item sm={4}>
              <FormControlLabel
                control={
                  <Switch checked={settingsForSelectedCustomer?.mapView} onChange={() => setSettingsForSelectedCustomer({ ...settingsForSelectedCustomer, mapView: !settingsForSelectedCustomer?.mapView })}></Switch>
                }
              />
            </Grid>

            <Grid item sm={8}>
              Geofence View:
            </Grid>

            <Grid item sm={4}>
              <FormControlLabel
                control={
                  <Switch checked={settingsForSelectedCustomer?.geofenceView} onChange={() => setSettingsForSelectedCustomer({ ...settingsForSelectedCustomer, geofenceView: !settingsForSelectedCustomer?.geofenceView })}></Switch>
                }
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSettingsForSelectedCustomer(null)}>Cancel</Button>
          <Button onClick={() => updateSettings()}>Save</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={errorLoader} PaperComponent={Paper} onClose={() => setErrorLoader(false)}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <DialogContentText>
            No results fetched for the given account query. Please try again with valid inputs.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button autoFocus onClick={() => setErrorLoader(false)} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={!!selectedFordisableCustomerDetails}>
        <DialogTitle>
          {selectedFordisableCustomerDetails?.currentDisableStatus ? 'Enable' : 'Disable'} Customer
        </DialogTitle>
        <DialogContent>
          Are you sure you want to{' '}
          {selectedFordisableCustomerDetails?.currentDisableStatus ? 'enable' : 'disable'} customer{' '}
          {selectedFordisableCustomerDetails?.customerName}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSelectedFordisableCustomerDetails(null)}>Cancel</Button>
          <Button
            onClick={() => toggleCustomerStatus(selectedFordisableCustomerDetails?.customerId)}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      {hasSnacks ? (
        <Snackbar key={new Date()} open={hasSnacks} autoHideDuration={6000} onClose={handleExit}>
          <Alert elevation={6} variant="filled" onClose={handleExit} severity="success">
            {hasSnacks ? JSON.parse(localStorage.getItem('snack'))['msg'] : ''}
            <Button size="small" onClick={handleClose}>
              OPEN
            </Button>
          </Alert>
        </Snackbar>
      ) : null}
    </>
  );
}
